import { Template } from "./article";
import { TopicIdeaPayloadForAIGeneration } from "./TopicIdeaPayloadForAIGeneration";
import { KeywordDocumentUploadData } from "./campaigns";

export class GenerateCampaignArticlesRequest extends TopicIdeaPayloadForAIGeneration {
    ArticleId: number = 0;
    CampaignTopic: string = "";
    CampaignGoal: string = "";
    Goal: string = "";
    Templates: Template[] = [];
    //contentInstructionDocuments?: ContentInstructionDocument[];
    pages?: PageConfiguration[];
    brandId?: string = null;
    // set by Revise and Generate - creates the articles without creating a project
    isReviseContent: boolean = false;
    originalArticleId: number = null;
}



export interface GenerateCampaignArticlesRequest extends TopicIdeaPayloadForAIGeneration {
    ArticleId: number;
    CampaignTopic: string;
    CampaignGoal: string;
    Goal: string;
    Templates: Template[];
    //contentInstructionDocuments?: ContentInstructionDocument[]; 
    pages?: PageConfiguration[]; 
    brandId?: string;
}

export class GenerateCampaignArticlesResponse {
  campaignId: string = "";
  status: string = "";
  activeCount:number;
}

export interface GenerateCampaignArticlesResponse {
  campaignId: string;
  status: string;
  activeCount: number;
}

export interface ContentInstructionDocument {
  name: string;
  type: string;
  path: string;
}

export class RetryGenerateCampaignArticlesForCustomTemplateRequest {
    campaignId: string = "";
    profileId: number = 0;
}

export class RetryGenerateCampaignArticlesForCustomTemplateResponse {
    campaignId: string = "";
    success: boolean = false;
    message: string = "";
    errorCode: number = 0;
}

export interface PageConfiguration {
  templateId: string; 
  pageUrl: string;
  title: string;
  keywords: string[];
}

export class ContentInstructionDocument {
  name: string = '';
  type: string = '';
  path: string = '';
}

export class PageConfiguration {
  templateId: string = ''; 
  pageUrl: string = '';
  title: string = '';
  keywords: string[] = [];
}

export class WebpageKeywordTemplateMappingRequest {
  BrandId?: string;
  Keywords?: string[];
  WebpageKeywords?: { [key: string]: string[] };
}

export class WebpageKeywordTemplateMappingResponse {
  webpageKeywordTemplateMappings?: WebpageKeywordTemplateMapping[];
  errorCode: number = 0;
  message: string = "";
  errors: string[] = [];
  success: boolean = false;
}

export class WebpageKeywordTemplateMapping {
  keywords?: string[];
  templateId?: number;
  templateName?: string;
  webPageName?: string;
  webPageId?: string;
}


export interface GenerateCampaignArticlesForCustomTemplateRequest extends TopicIdeaPayloadForAIGeneration {
  articleId?: number;
  campaignTopic?: string;
  campaignGoal?: string;
  goal?: string;
  templates?: Template[];
  //contentInstructionDocuments?: ContentInstructionDocument[];
  pages?: PageConfiguration[];
  brandId?: string;
  urls?: string[];
  isIndividualUrls?: boolean;
  profileId?: number;
  businessId?: number;
  profileName?: string;
  keywords?: string[];
  highlights: { [key: string]: string[] };
  files: FileInfo[];
  keywordDocumentData?: KeywordDocumentUploadData;
  keywordDocumentFile?: File;
}

export class GenerateCampaignArticlesForCustomTemplateRequest extends TopicIdeaPayloadForAIGeneration {
    ArticleId: number = 0;
    CampaignTopic: string = "";
    CampaignGoal: string = "";
    Goal: string = "";
    Templates: Template[] = [];
    //contentInstructionDocuments?: ContentInstructionDocument[];
    pages?: PageConfiguration[];
    brandId?: string = null;
    urls?: string[] = [];
    isIndividualUrls?: boolean = false;
    profileId?: number = 0;
    businessId?: number = 0;
    profileName?: string = "";
    keywords?: string[] = [];
    highlights: { [key: string]: string[] } = {};
    files: FileInfo[] = [];
    keywordDocumentData?: KeywordDocumentUploadData;
    keywordDocumentFile?: File;
}
export class FileInfo {
  file: File;
  documentType: string = '';
  documentDescription: string = '';
}

